module.exports = __webpack_public_path__ + "static/media/42x40-15.507b83b9.png";